/* Catalog facets operate on the full collection, including every Shopify page. */
(() => {
  'use strict';
  function initCatalog(root) {
    if (root.dataset.fxReady) return;
    root.dataset.fxReady = 'true';
    const find = selector => root.querySelector(selector);
    const controls = find('[data-fx-catalog-controls]');
    const fields = find('.fx-filter-fields');
    const grid = find('[data-fx-catalog-grid]');
    const nativeSearch = find('[data-fx-native-search]');
    const pagination = find('[data-fx-catalog-pagination]');
    const status = find('[data-fx-catalog-status]');
    const error = find('[data-fx-catalog-error]');
    const retry = find('[data-fx-catalog-retry]');
    const sub = find('[data-fx-subcategory]');
    const query = find('[data-fx-catalog-query]');
    const empty = find('[data-fx-catalog-empty]');
    const buttons = [...root.querySelectorAll('[data-fx-category]')];
    const categories = new Set(buttons.map(button => button.dataset.fxCategory));
    const allSubOptions = [...sub.options].map(option => ({value:option.value,category:option.dataset.category}));
    let items = [], ready = false, loading = false, category = 'all', timer;
    controls.hidden = false;
    function matchesCategory(item, selected = category) {
      return selected === 'all' || (selected === 'sets' ? item.dataset.isSet === 'true' : item.dataset.category === selected);
    }
    function restore() {
      const params = new URL(window.location.href).searchParams;
      category = categories.has(params.get('fx_category')) ? params.get('fx_category') : 'all';
      const selectedSub = params.get('fx_subcategory') || 'all';
      const option = allSubOptions.find(option => option.value === selectedSub);
      sub.value = option && (category === 'all' || category === 'sets' || option.category === category) ? selectedSub : 'all';
      query.value = (params.get('fx_q') || '').slice(0,150);
    }
    function updateURL(push = false) {
      const url = new URL(window.location.href);
      for (const [key,value] of [['fx_category',category],['fx_subcategory',sub.value],['fx_q',query.value.trim()]]) {
        if (!value || value === 'all') url.searchParams.delete(key);
        else url.searchParams.set(key,value);
      }
      url.searchParams.delete(root.dataset.pageParam || 'page');
      url.hash = 'catalogus';
      if (url.href !== window.location.href) window.history[push ? 'pushState' : 'replaceState']({},'',url);
    }
    function apply() {
      if (!ready) return;
      const term = query.value.trim().toLocaleLowerCase((document.documentElement.lang.startsWith('nl')?'nl-NL':'en-US'));
      let visible = 0;
      items.forEach(item => {
        const match = matchesCategory(item) && (sub.value === 'all' || item.dataset.subcategory === sub.value) && (!term || (item.dataset.search || '').toLocaleLowerCase((document.documentElement.lang.startsWith('nl')?'nl-NL':'en-US')).includes(term));
        item.hidden = !match;
        if (match) visible++;
      });
      buttons.forEach(button => {
        const selected = button.dataset.fxCategory;
        const count = items.filter(item => matchesCategory(item,selected)).length;
        button.hidden = !count && !['all',category].includes(selected);
        button.setAttribute('aria-pressed',String(category === selected));
        button.querySelector('[data-fx-category-count]').textContent = String(count);
      });
      [...sub.options].forEach(option => {
        const allowed = !option.dataset.category || category === 'all' || category === 'sets' || option.dataset.category === category;
        option.hidden = !allowed;
        option.disabled = !allowed;
      });
      [...sub.querySelectorAll('optgroup')].forEach(group => {group.hidden = [...group.children].every(option => option.hidden);});
      const label = buttons.find(button => button.dataset.fxCategory === category)?.querySelector('span').textContent;
      status.textContent = window.FlexxesText("${0} van ${1} producten${2}", visible, items.length, category !== 'all' ? ' · '+label : '');
      empty.hidden = visible > 0;
      root.querySelectorAll('[data-fx-catalog-reset]').forEach(button => {button.hidden = category === 'all' && sub.value === 'all' && !term;});
    }
    async function fetchPage(url) {
      const target = new URL(url,window.location.href);
      if (target.origin !== window.location.origin) throw new Error('Unexpected collection origin');
      target.searchParams.set('section_id',root.dataset.sectionId);
      const current = new URL(window.location.href);
      if (current.searchParams.has('preview_theme_id')) target.searchParams.set('preview_theme_id',current.searchParams.get('preview_theme_id'));
      const abort = new AbortController();
      const timeout = setTimeout(() => abort.abort(),15000);
      try {
        const response = await fetch(target.href,{credentials:'same-origin',signal:abort.signal,headers:{Accept:'text/html'}});
        if (!response.ok) throw new Error('Collection unavailable');
        const parsed = new DOMParser().parseFromString(await response.text(),'text/html');
        const section = [...parsed.querySelectorAll('[data-fx-catalog]')].find(node => node.dataset.sectionId === root.dataset.sectionId);
        if (!section) throw new Error('Collection section missing');
        return section;
      } finally {clearTimeout(timeout);}
    }
    async function load() {
      if (loading || ready) return;
      loading = true;fields.disabled = true;error.hidden = true;retry.hidden = true;
      status.textContent = window.FlexxesText("De categorieën worden geladen…");
      try {
        let page = root;
        if (Number(root.dataset.page) > 1) {
          const first = new URL(window.location.href);
          first.searchParams.set(root.dataset.pageParam || 'page','1');
          page = await fetchPage(first.href);
        }
        const collected = new Map(), visited = new Set(), omitted = new Set();
        let expected = Number(page.dataset.total);
        while (page) {
          for(const marker of page.querySelectorAll('[data-fx-omitted]'))omitted.add(marker.dataset.fxOmitted);
          for (const item of page.querySelectorAll('[data-fx-catalog-grid] > [data-fx-item]')) collected.set(item.dataset.handle,item);
          status.textContent = window.FlexxesText("Categorieën laden: ${0} van ${1} producten…", collected.size, expected);
          const next = page.dataset.next;
          if (!next) break;
          if (visited.has(next) || visited.size >= 100) throw new Error('Incomplete pagination');
          visited.add(next);
          page = await fetchPage(next);
        }
        if (!Number.isFinite(expected) || collected.size + omitted.size !== expected) throw new Error('Incomplete collection');
        if (!root.isConnected) return;
        items = [...collected.values()];
        grid.replaceChildren(...items);
        nativeSearch.hidden = true;pagination.hidden = true;
        ready = true;fields.disabled = false;
        restore();apply();window.FlexxesQuote?.render(root);
      } catch (_) {
        status.textContent = window.FlexxesText("Gebruik zoeken om apparatuur te vinden.");
        error.hidden = false;retry.hidden = false;
        nativeSearch.hidden = false;pagination.hidden = false;
      } finally {loading = false;}
    }
    root.addEventListener('click',event => {
      const button = event.target.closest('[data-fx-category]');
      if (button && ready) {category = button.dataset.fxCategory;sub.value = 'all';apply();updateURL(true);}
      if (event.target.closest('[data-fx-catalog-reset]') && ready) {category = 'all';sub.value = 'all';query.value = '';apply();updateURL(true);}
    });
    sub.addEventListener('change',() => {apply();updateURL(true);});
    query.addEventListener('input',() => {clearTimeout(timer);timer = setTimeout(() => {apply();updateURL();},120);});
    window.addEventListener('popstate',() => {if(root.isConnected){restore();apply();}});
    retry.addEventListener('click',() => {root.fxCatalogReady = load();});
    root.fxCatalogReady = load();
  }
  function init(scope=document) {scope.querySelectorAll('[data-fx-catalog]').forEach(initCatalog);}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => init());else init();
  document.addEventListener('shopify:section:load',event => init(event.target));
})();
